import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useEnergySavings } from '@/hooks/useEnergySavings';
import { useStores } from '@/hooks/use-stores';
import { BaseEnergySavingsProps } from '@/comp/pages/ValueDashboardPage/EnergySavings/EnergySaving.interface';

import BaseEnergySavings from '../BaseEnergySavings';
import LifetimeSavings from '../LifetimeSavings';

const EnergySavings = observer((props: BaseEnergySavingsProps) => {
  const { t } = useTranslation();
  const { energySavingsStore, stationStore } = useStores();
  const { options } = useEnergySavings(props.animation);

  const lifetimeSavings = energySavingsStore.energySavings.lifetimeSavings;

  return (
    <BaseEnergySavings {...props} title={t('EnergySavings')} highchartOptions={options}>
      <LifetimeSavings
        loading={!energySavingsStore.isReady || stationStore.isLoading}
        title={t('LIFE TIME SAVINGS')}
        displayPercentage={lifetimeSavings?.percentageFormatted}
        percentageText={lifetimeSavings?.percentageFormatted}
        displayPower={lifetimeSavings?.energyKwhFormatted}
        powerText={`(${lifetimeSavings?.energyKwhFormatted} kW)`}
        displayItemChip={lifetimeSavings?.savingText}
        chipText={lifetimeSavings?.savingText}
        displayCo2Saving={lifetimeSavings?.co2SavingFormatted}
        co2SavingValue={lifetimeSavings?.co2SavingFormatted}
      />
    </BaseEnergySavings>
  );
});

export default EnergySavings;
